import { create } from 'zustand';
import type { UpgradeWallContext } from '@/types/billing';

interface UpgradeWallState {
  open: boolean;
  context: UpgradeWallContext | null;
  show: (ctx: UpgradeWallContext) => void;
  hide: () => void;
}

export const useUpgradeWallStore = create<UpgradeWallState>((set) => ({
  open: false,
  context: null,
  show: (ctx) => set({ open: true, context: ctx }),
  hide: () => set({ open: false }),
}));

/** Wire the global window event dispatched by httpClient on HTTP 402. */
if (typeof window !== 'undefined') {
  window.addEventListener('hiromatch:upgrade-wall', (e: Event) => {
    const detail = (e as CustomEvent<UpgradeWallContext>).detail;
    if (detail?.reason) {
      useUpgradeWallStore.getState().show(detail);
    }
  });
}